<ion-header *ngIf="!standalone">
  <leplace-toolbar [menu]="false" [leftButtonDisabled]="false" [leftButton]="appIconsStandard.home" [leftIcon]="true"
    (leftClick)="back()" [title]="title" [loading]="!loaded || loading">
  </leplace-toolbar>
</ion-header>

<ion-content [ngClass]="theme">
  <div class="view-frame theme-background" fxLayout="column">

    <ion-searchbar class="ion-searchbar-custom info-text-mlg" [(ngModel)]="autocompleteQuery" ngDefaultControl
      showCancelButton="never" (ionInput)="updateSearch()"></ion-searchbar>

    <div class="padding-s" fxLayout="column">
      <div>
        <ion-fab vertical="top" horizontal="end" class="place-selector-margin-top-fab">
          <blink-button class="place-selector-margin-right-fab" theme="primary70" [icon]="appIconsStandard.search"
            [fab]="true" (select)="zoomOut()" [noBorder]="true" [huge]="false">
          </blink-button>
        </ion-fab>
        <div *ngIf="showMapDiv" id="mapId" [class]="standalone ? 'map-view-selector-standalone' : 'map-view-selector'">
        </div>
        <div *ngIf="!showMapDiv" class="progress-spinner-center">
          <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate">
          </mat-progress-spinner>
        </div>
      </div>
    </div>
  </div>
</ion-content>